<template>
    <div class="btn-group">
        <!-- <li
        :style="{
          '--fontColor2': style.fontColor2,
          '--fontFamily': style.fontFamily
        }"
        @click="toggleMenu()" class="seat-dropdown-toggle" v-if="selectedOption !== undefined">
          <span class="ss--city">{{ initialPassenger.name }}</span>
          <i v-if="options.length > 1" class="fas fa-angle-down"></i>

            <span v-if="initialPassenger.seat.designator">
              <span v-if="locale == 'he' ||  locale == 'ar'">{{ initialPassenger.seat.designator }} {{ text.seat }}</span>
              <span v-else>{{ text.seat }} {{ initialPassenger.seat.designator }} </span>
            </span>
            <span v-else>{{ text.no_seat_selected }}</span>
        </li> -->


        <div
          :style="{
          '--fontColor2': style.fontColor2,
          '--fontFamily': style.fontFamily
        }"
        @click="toggleMenu()" class="seat-dropdown-toggle" v-if="selectedOption !== undefined"
        >
          <div class="selected-option-info">
            <span><strong>{{ initialPassenger.name }}</strong></span>

            <span v-if="initialPassenger.seat && initialPassenger.seat.designator">
              <span v-if="locale == 'he' ||  locale == 'ar'">{{ initialPassenger.seat.designator }} {{ text.seat }}</span>
              <span v-else>{{ text.seat }} {{ initialPassenger.seat.designator }} </span>
            </span>
            <span v-else>{{ text.no_seat_selected }}</span>

          </div>

            <div>
            <i v-if="options.length > 1" class="fas fa-angle-down"></i>
            </div>

        </div>

        <ul class="seat-dropdown-menu" v-if="showMenu">
            <li v-for="option in options" :key="option.id">
                <a
                :style="{
                  '--fontColor2': style.fontColor2,
                  '--fontFamily': style.fontFamily,
                  '--passengerSelectedColor': style.passengerSelectedColor
                }"
                href="javascript:void(0)" @click="updateOption(option)">
                  {{ option.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      selectedOption: null,
      showMenu: false,
      placeholderText: 'Please select an item'
    }
  },
  props: {
    options: {
      type: [Array, Object]
    },
    selected: {},
    placeholder: [String],
    updater: null
  },

  mounted () {
    this.selectedOption = this.selected
    if (this.placeholder) {
      this.placeholderText = this.placeholder
    }
    //window.EventBus.dispatchEvent('ss-seat-selection-mounted')

  },

  computed: {
    initialFlight () {
      var _this = this
      var flightLabels = this.options.filter(function (option) {
        return option.id === _this.selectedOption
      })
      if (flightLabels.length === 1) {
        return flightLabels[0]
      }

      return {
        label: '...',
        from: '...',
        to: '...'
      }
    },

    initialPassenger(){
      var _this = this
      var passengerLabels = this.options.filter(function (option) {
        return option.id === _this.selectedOption
      })
      if (passengerLabels.length === 1) {
        return passengerLabels[0]
      }

      return {
        label: '...',
        name: '...'
      }
    },
    ...mapGetters(['style', 'flights','text','locale'])
  },

  methods: {
    updateOption (option) {
      this.selectedOption = option.id
      this.showMenu = false
      this.updater(this.selectedOption)
    },

    updateSelectedOption (optionId) {
      this.selectedOption = optionId
      this.showMenu = false
      // this.updater(this.selectedOption)
    },

    toggleMenu () {
      if (this.options.length > 1) {
        this.showMenu = !this.showMenu
      }
    }
  }
}
</script>
<style>
#ss-container .btn-group {
  width: 100%;
  max-width: 220px !important;
  height: inherit;
  position: relative;
  padding: 0 10px;
  margin: 0px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: flex-start;
}
.btn-group a:hover {
  text-decoration: none;
}
.seat-dropdown-toggle {
  /*color: var(--fontColor2);*/
  width: 100%;
  height: inherit;
  text-transform: none;
  font-family: var(--fontFamily);
  font-size: 12px;
  border: 0;
  border-radius: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: space-between;
  -ms-align-items: center;
  align-items: center;
  /*justify-content: space-between;*/
  padding-right: 5px;
}

.seat-dropdown-toggle .selected-option-info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: inherit;
  overflow-wrap: anywhere;
}

.seat-dropdown-toggle .selected-option-info span{
  font-size: 12px !important;
}

.seat-dropdown-toggle .selected-option-info span:nth-child(2){
  overflow: hidden;
}

.seat-dropdown-toggle:hover {
  cursor: pointer;
}
.seat-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  width: 100%;
  padding: 5px 0;
  /* margin: 15px 0; */
  list-style: none;
  font-size: 12px;
  text-align: left;
  background-color: #FFFFFF;
  border: 1px solid #CDCECF;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0,0,0,.1);
}
.seat-dropdown-menu > li > a {
  color: var(--fontColor2);
  font-family: var(--fontFamily);
  padding: 0px 15px;
  margin: 0 0 5px;
  display: block;
  clear: both;
  font-weight: normal;
  white-space: nowrap;
  text-decoration: none;
  height: 30px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: flex-start;
}
.seat-dropdown-menu > li:last-of-type > a {
  margin-bottom: 0;
}
.seat-dropdown-menu > li > a:hover {
  color: var(--passengerSelectedColor);
}
.seat-dropdown-menu > li {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin: 0;
}
#ss-container li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Lib/PassengersDropdown.vue